module.exports = __webpack_public_path__ + "img/oufu_50x68x9b.prt.2bcfe3ae.jpg";